export default __webpack_public_path__ + "static/tauseef-bba2fb478dd5fe526feeaf2352d24f89.png";